export default "__VITE_ASSET__Blv86ZNP__"